<div class="flex-col toolbar-wrapper">
  <mat-toolbar class="doenkids-main-toolbar ">
    <div class="toolbar-container flex-row flex-1">
      <div class="left-side">
        @if (isLoggedIn$ | async) {
          @if (isXSmall$ | async) {
            <button
              type="button"
              [attr.aria-label]="'doenkids_menu_bar.sidenav_toggle.label' | translate"
              mat-icon-button
              (click)="toggleDrawer()"
              class="sidenav-button">
              <mat-icon [attr.aria-label]="'doenkids_menu_bar.sidenav_toggle.icon_label' | translate">menu</mat-icon>
            </button>
          }
          @if (showBackButton) {
            <button
              type="button"
              [attr.aria-label]="'doenkids_menu_bar.go_back.label' | translate"
              mat-icon-button
              (click)="navigateBack()"
              class="back-button">
              <mat-icon [attr.aria-label]="'doenkids_menu_bar.go_back.icon_label' | translate">arrow_back</mat-icon>
            </button>
          }
          <ng-content select="[left]"></ng-content>
        }
      </div>
      <div class="right-side flex-row justify-center items-center" >
        @if (isLoggedIn$ | async) {
          <ng-content select="[right]" ></ng-content>
        }
        @if (isLoggedIn$ | async) {
          <button
            mat-icon-button
            type="button"
            (click)="logout()"
            [matTooltip]="'doenkids_menu_bar.logout' | translate"
            >
            <mat-icon>exit_to_app</mat-icon>
          </button>
        }
      </div>
    </div>
  </mat-toolbar>

  @if (loading) {
    <div class="progress-container" [class.visibility]="loading">
      <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
    </div>
  }
</div>


